import React from "react";
import { Table } from "antd";
import CircleIIcon from "../../../../../assets/circle_i.svg";
import { useSelector } from "react-redux";
import { removeAccountPrefixFromLabels } from "../../../../../../src/global/utility/Utils";
import ATSToolTip from "../../../../../global/components/ATSToolTip";
import { getScheduleSummary } from "../../../../../global/utility/scheduleTimeUtils";

function ReviewAttributes() {
  const { attributes, fields, attributeKeys } = useSelector((state) => ({
    fields: state.deviceProfile.ui.form.fields.step2,
    attributes: state.deviceProfile.ui.form.fields.step1.attributes || [],
    attributeKeys: Object.keys(
      state.deviceProfile.ui.form.fields.step2 || {}
    ).filter((attrKey) => attrKey !== "autoResolveForAllAlert"),
  }));
  const getMinimum = (title, fallback) => {
  if (title?.startsWith("Anymotion")) return 0.1;
  if (title?.startsWith("Shock")) return 0;
  if (title?.startsWith("Tilt")) return 3;
  return fallback;
  };
  const getFieldValue = (field) =>
  typeof field === "object" ? field?.value : field;
const getMaximum = (title, fields, key) => {
  if (title?.startsWith("Tilt")) return getFieldValue(fields[key]?.tiltAngle);
  if (title?.startsWith("Anymotion")) return getFieldValue(fields[key]?.accelThresh);
  if (title?.startsWith("Shock")) return getFieldValue(fields[key]?.shockThresh);
  return getFieldValue(fields[key]?.maximum);
};

  const dataSource =
    attributeKeys.length > 0
      ? attributeKeys
          .filter((_, index) => attributes[index]?.title)
          .map((attributeKey, index) => ({
            key: attributeKey,
            attribute: attributes[index]?.title?.startsWith("rfSignal") ? "Cellular Signal Strength (dBm)" : attributes[index]?.title,
            minimum: getMinimum(attributes[index]?.title, fields[attributeKey]?.minimum?.value),
            maximum: getMaximum(attributes[index]?.title,fields,attributeKey),
           // minimum: fields[attributeKey]?.minimum?.value,
           // maximum: fields[attributeKey]?.maximum?.value,
            alertType: fields[attributeKey]?.alertType?.value || "None",
            alertGroup:
              Array.isArray(fields[attributeKey]?.alertGroup?.value) &&
                fields[attributeKey]?.alertGroup?.value?.length > 0
                ? removeAccountPrefixFromLabels(fields[attributeKey]?.alertGroup?.value).join(" , ")
                : "None",
            alert: fields[attributeKey]?.alert?.value ?  fields[attributeKey]?.alert?.value?.charAt(0)?.toUpperCase() + fields[attributeKey]?.alert?.value?.slice(1)?.toLowerCase() : "Platform alert",
            schedule: getScheduleSummary(fields[attributeKey]?.schedule),
          }))
      : [];
  const columns = [
    {
      title: <span className="font-face-vzw">Attribute</span>,
      dataIndex: "attribute",
      key: "attribute",
    },
    {
      title: (
        <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
                   Alert 
                   <ATSToolTip text="Alert trigger based on">
                     <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                   </ATSToolTip>
                 </span>
      ),
        dataIndex: "alert",
        key: "alert",
    },
    {
      title: <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
                  Min
                  <ATSToolTip text="Minimum value">
                    <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                  </ATSToolTip>
                </span>,
      dataIndex: "minimum",
      key: "minimum",
    },
    {
      title: <span className="font-face-vzw" style={{display: "flex", alignItems: "center" }}>
                  Max
                  <ATSToolTip text="Maximum value">
                    <img src={CircleIIcon} className="mx-1" alt="info" style={{ verticalAlign: "middle" }} />
                  </ATSToolTip>
                </span>,
      dataIndex: "maximum",
      key: "maximum",
    },
    {
      title: (
        <span className="font-face-vzw">
          Alert Type <ATSToolTip text="Severity level of the alert"><img src={CircleIIcon} className="mx-1" alt="info" /></ATSToolTip>
        </span>
      ),
      dataIndex: "alertType",
      key: "alertType",
      render: (text) => (text && text.length > 0 ? `${text[0].toUpperCase()}${text.substring(1)}` : "None"),
    },
    {
      title: (
        <span className="font-face-vzw">
          Alert Group <ATSToolTip placement={"topRight"} text="Alert groups to be notified of the alert"><img src={CircleIIcon} className="mx-1" alt="info" /></ATSToolTip>
        </span>
      ),
      dataIndex: "alertGroup",
      key: "alertGroup",
    },
    {
      title: <span className="font-face-vzw">Schedule</span>,
      dataIndex: "schedule",
      key: "schedule",
    },
  ];
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Attributes
      </div>
      <Table
        className="review-table"
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
    </>
  );
}

export default ReviewAttributes;
